import React from 'react';
import { useLocation } from 'react-router-dom';

type Params = { [key: string]: string };

export default function useQuery() {
  const { search } = useLocation();

  const queryParams = React.useMemo(
    () => new URLSearchParams(search),
    [search],
  );
  let params: Params = {};
  queryParams.forEach((value, key) => {
    params = { ...params, [key]: value };
  });
  return params;
}
